export class HideShowPollList {
    constructor(optionalOptions = {}) {
        this._blocks = document.querySelectorAll('[data-show="items"]');
        if (!this._blocks) {
            this.destructor();
            return true;
        }

        let thasBlocks = this._blocks;

        function toogle(id, close) {
            let byId = document.getElementById(id);
            let blocksChilds;
            let blocks = thasBlocks
            if (byId) {
                let blocks = byId;
            }

            for (let i = 0; i < blocks.length; ++i) {
                let block = blocks[i];

                blocksChilds = block.children
                if (blocksChilds.length > 0) {
                    for (let ii = 0; ii < blocksChilds.length; ++ii) {
                        if (ii >= 3) {
                            if (close) {
                                blocksChilds[ii].classList.add('d-none')
                            } else {
                                blocksChilds[ii].classList.remove('d-none')
                            }
                        }
                    }
                }
            }
        }

        toogle('test-123',true);

        let showHideButton = document.querySelectorAll('[data-show-button]');
        if (showHideButton) {
            for (let i = 0; i < showHideButton.length; ++i) {
                showHideButton[i].addEventListener('click', (e) => {
                    if (showHideButton[i].classList.contains('opened')) {
                        showHideButton[i].classList.remove('opened')
                        showHideButton[i].querySelector(showHideButton[i].dataset.change).innerHTML = showHideButton[i].dataset.default
                        toogle(showHideButton[i].dataset.target, true)
                    } else {
                        showHideButton[i].classList.add('opened')
                        showHideButton[i].querySelector(showHideButton[i].dataset.change).innerHTML = showHideButton[i].dataset.inhide
                        toogle(showHideButton[i].dataset.target, false)
                    }
                });
            }
        }
    }

    destructor() {
        this._pollBlocks = null;
    }
}

export default new HideShowPollList();